import { render, staticRenderFns } from "./Tel-Input.vue?vue&type=template&id=7b80d465&"
import script from "./Tel-Input.vue?vue&type=script&lang=js&"
export * from "./Tel-Input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Tel-Input.vue"
export default component.exports